export const MODAL_SPLIT_MODE_LIST = [
    "walking",
    "cycling",
    "motorizedPrivateTransport",
    "publicBus",
    "publicRail",
];
